// extracted by mini-css-extract-plugin
export var docenteItem = "DocenteItem-module--docente-item--Pyo1V";
export var imageContainer = "DocenteItem-module--image-container--GOU4w";
export var textContainer = "DocenteItem-module--text-container--FtN1Q";